<template>
  <nav
    class="fixed flex justify-between py-3 md:py-6 w-full lg:px-48 md:px-12 px-4 content-center z-50 transition-all duration-300"
    :class="scrolled
      ? 'bg-secondary shadow-sm text-black'
      : 'bg-transparent text-white'"
  >
    <div class="flex items-center">
      <NuxtLink :to="localePath('/')">
        <AppLogo :inverted="scrolled" />
      </NuxtLink>
    </div>

    <ul class="font-montserrat items-center hidden md:flex">
      <li class="mx-3">
        <NuxtLink class="growing-underline" :to="localePath('/') + '#about'">{{ t('about.title') }}</NuxtLink>
      </li>
      <li class="mx-3">
        <NuxtLink class="growing-underline" :to="localePath('/') + '#lessons'">{{ t('lessons.title') }}</NuxtLink>
      </li>
    </ul>

    <div class="font-montserrat hidden md:flex items-center gap-3">
      <NuxtLink
        v-for="loc in locales"
        :key="loc.code"
        :to="switchLocalePath(loc.code)"
        class="growing-underline text-sm uppercase"
        :class="locale === loc.code ? 'font-bold' : 'opacity-50'"
      >
        {{ loc.code }}
      </NuxtLink>
    </div>

    <div class="md:hidden cursor-pointer" @click="mobileOpen = true">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
      </svg>
    </div>
  </nav>

  <!-- Mobile menu -->
  <div
    v-if="mobileOpen"
    class="px-4 py-6 fixed top-0 left-0 h-full w-full bg-secondary z-[100] animate-fade-in-down text-black"
  >
    <div class="flex justify-end items-center py-4">
      <button
        class="p-3 -mr-3"
        aria-label="Закрити меню"
        @click.stop="mobileOpen = false"
      >
        <svg class="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <ul class="font-montserrat flex flex-col mx-8 my-24 items-center text-3xl">
      <li class="my-6"><NuxtLink :to="localePath('/') + '#about'" @click="mobileOpen = false">{{ t('about.title') }}</NuxtLink></li>
      <li class="my-6"><NuxtLink :to="localePath('/') + '#lessons'" @click="mobileOpen = false">{{ t('lessons.title') }}</NuxtLink></li>
    </ul>
    <div class="flex justify-center gap-8 mt-8">
      <NuxtLink
        v-for="loc in locales"
        :key="loc.code"
        :to="switchLocalePath(loc.code)"
        class="text-2xl uppercase"
        :class="locale === loc.code ? 'font-bold' : 'opacity-50'"
        @click="mobileOpen = false"
      >
        {{ loc.code }}
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const { t, locale, locales } = useI18n()
const localePath = useLocalePath()
const switchLocalePath = useSwitchLocalePath()
const mobileOpen = ref(false)
const scrolled = ref(false)

function onScroll() {
  scrolled.value = window.scrollY > 80
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>
